//AppMain component added to govern session for all child components
import React from "react";
import Layout from "../components/Layout";
import AutoLogout from "./AutoLogout";

const AppMain: React.FunctionComponent<any> = () => {
  return (
    <AutoLogout>
      <Layout />
    </AutoLogout>
);
};

export default AppMain;
